/* eslint-disable */
import React from "react";
import { Typography, Box, IconButton, Tooltip, Divider, Avatar } from "@material-ui/core";
import { isIE } from "react-device-detect";
import SignOut from "../../icons/SignOut";
import Link from "../../shared/ui/Link";
import { useAuth } from "../../modules/auth/shared/hooks/useAuth";
import { useUser } from "../../modules/user/shared/hooks/useUser";
import { useStyles } from "./styles";
import { FormattedMessage } from "react-intl";
import messages from "./messages";
import Search from "../../icons/Search";
import { browserHistory } from "../../routes/history";

const MAX_STRING_LENGTH = 30;

export default AccountBar;

export function AccountBar() {
  const classes = useStyles();
  const [isAuth, , , logout] = useAuth();

  const [user] = useUser();

  if (!isAuth) {
    return null;
  }

  const getStringToDisplay = (string: string) => {
    if (string.length > MAX_STRING_LENGTH) {
      return `${string.slice(0, MAX_STRING_LENGTH)}...`;
    } else {
      return string;
    }
  };

  const getNameToDisplay = () => {
    return <span>{getStringToDisplay(`${user.name} ${user.surname}`)}</span>;
  };

  const toUserRoute = () => {
    browserHistory.push("/user");
  };

  return (
    <Box className={classes.root}>
      {/* <IconButton className={classes.searchIcon}>
        <Search />
      </IconButton>
      <Divider orientation="vertical" className={classes.divider} /> */}
      <Box className={classes.typography}>
        <Typography className={classes.status}>
          <FormattedMessage {...messages.loggedInAs} />
        </Typography>
        <Link className={classes.link} active={true} to={"/user"}>
          <Tooltip title={`${user.name} ${user.surname}`}>
            <Typography className={classes.accountname}>{getNameToDisplay()}</Typography>
          </Tooltip>
        </Link>
      </Box>
      {isIE ? (
        <div className={classes.avatarIE}>
          <img src={user.profilePicture || `${process.env.PUBLIC_URL}/assets/images/Profile_avatar_placeholder_large.png`} className={classes.avatarIEImage} />
        </div>
      ) : (
        <Avatar src={user.profilePicture} className={classes.avatar} />
      )}
      <IconButton className={classes.button} aria-label="sign out" onClick={logout} disableRipple disableFocusRipple>
        <SignOut />
      </IconButton>
    </Box>
  );
}
